import React, { Component, Fragment } from "react";
import Async from "react-select";
import modalIcon from "../../../assets/images/testIcon.svg";
import Switch from "react-toggle-switch";
import Field from "../../Common/Field/Field";
import ModuleHeader from "../ModuleHeader";
import FileUpload from "../../FileUpload/FileUpload";
import Button from '../../Buttons/Button'
import ButtonIcon from "../../Costing/Button/ButtonIcon";

export default class EmbroideryModule extends Component {
  state = {
    _id: "",
    embroidery: [],
    assignedToList: [],
    STATUS: [],
    disabled: false,
    widthList: [],
    backingArray: [],
  };

  componentWillMount() {
    const { _id, embroidery, embroideryProcess, assignedToList, STATUS, disabled, BACKINGTYPE, PLACEMENT, EMBPLACEMENT, NOOFCOLORS, FRAMES, LEFTVALUES, PRICE1000STICHES, widthList, EMBFORM } = this.props;
    this.setState({
      _id,
      embroidery,
      embroideryProcess,
      assignedToList,
      STATUS,
      BACKINGTYPE,
      EMBFORM,
      PLACEMENT,
      LEFTVALUES,
      PRICE1000STICHES,
      EMBPLACEMENT,
      NOOFCOLORS,
      FRAMES,
      widthList,
      disabled
    });
  }

  componentWillReceiveProps(nextProps) {
    const { _id, embroidery, embroideryProcess, assignedToList, STATUS, disabled, BACKINGTYPE, PLACEMENT, EMBFORM, EMBPLACEMENT, NOOFCOLORS, FRAMES, LEFTVALUES, PRICE1000STICHES, widthList } = nextProps;
    this.setState({
      _id,
      embroidery,
      embroideryProcess,
      assignedToList,
      STATUS,
      BACKINGTYPE,
      EMBFORM,
      PLACEMENT,
      EMBPLACEMENT,
      NOOFCOLORS,
      FRAMES,
      LEFTVALUES,
      PRICE1000STICHES,
      widthList,
      disabled
    });
  }

  toggleChange = (name, value) => {
    let toggle = { ...this.state.toggle };
    toggle[name] = value;
    this.setState({ toggle });
  };



  render() {
    let { toggle, embroidery, STATUS } = this.state;
    const { permissions } = this.props;
    return (
      <div
        class="card-filter meeting-min-con"
        id="embroidery"
        style={{ marginBottom: ".5%" }}
      >
        <div class="col-md-12">
          <ModuleHeader header={"Embroidery"} onClick={this.onOpenModal} _id={this.state._id}
            process={this.state.embroideryProcess}
            moduleName={"embroidery"}
            disabled={this.state.disabled}
            updateModulesMain={this.props.updateModulesMain}
            statusList={STATUS}
          />
          <div class="col-md-12 product-form" style={{ paddingBottom: "1%" }}>
            <div class="wash-container">
              <form name="embroideryForm">
                <div class="col-md-12 no-padding">
                  <div class="col-md-12 no-padding">
                    {/* <div class="col-md-2 step-one">
                      <div class="form-group">
                        <label for="ref-no">Assigned To</label>
                        <br />
                        <div class="custom-async-select">
                            <Async
                                name="assignedTo"
                                value={embroidery.assignedTo}
                                // onInputChange={this.getDoneBy}
                                // onChange={e =>
                                //   this.changeAssignedTo(e, "patternAssignedTo")
                                // }
                                placeholder="Find Assigned To"
                                options={this.state.assignedToList}
                                disabled = {true}
                            />
                        </div>
                      </div>
                    </div> */}
                    {/* <div class="col-md-2 step-one">
                        <Field
                            isFormGroup={true}
                            inputType="select"
                            inputName="status"
                            value={embroidery.status}
                            options={this.state.STATUS}
                            onChange={this.props.updateEmbroidery}
                            index ={index}
                            label = {"Status "}
                            disabled={this.state.disabled}
                        />
                    </div> */}
                    {/* <div class="col-md-2 step-one">
                      <Field
                        isFormGroup={true}
                        inputType="date"
                        inputName="completedDate"
                        label="Date Completed"
                        value={embroidery.completedDate}
                        index ={index}
                        onChange={this.props.updateEmbroidery}
                        disabled={this.state.disabled}
                      />
                    </div> */}
                  </div>
                  {/* Start of Content Embroiedry */}
                  <div className="col-md-12 no-padding">
                    <div className="col-md-12 embroid-mul">
                      <div className="col-md-2 step-one text-center">
                        <p className="manage_permissions emb-chck">
                          <input
                            type="checkbox"
                            className="filled-in"
                            id="filled-in-box1"
                            checked={embroidery.cutPanel}
                            disabled={this.state.disabled}
                            onChange={e => this.props.updateEmbroidery("cutPanel", e.target.checked)}
                          />
                          <label for="filled-in-box1">Cut Panel</label>
                        </p>
                      </div>
                      <div className="col-md-2 step-one text-center">
                        <p className="manage_permissions emb-chck">
                          <input
                            type="checkbox"
                            className="filled-in"
                            id="filled-in-box2"
                            checked={embroidery.allOver}
                            disabled={this.state.disabled}
                            onChange={e => this.props.updateEmbroidery("allOver", e.target.checked)}
                          />
                          <label for="filled-in-box2">All Over</label>
                        </p>
                      </div>
                      <div className="col-md-2 step-one text-center">
                        <p className="manage_permissions emb-chck">
                          <input
                            type="checkbox"
                            className="filled-in"
                            id="filled-in-box3"
                            checked={embroidery.garmentForm}
                            disabled={this.state.disabled}

                            onChange={e => this.props.updateEmbroidery("garmentForm", e.target.checked)}
                          />
                          <label for="filled-in-box3">Garment Form</label>
                        </p>
                      </div>
                      <div className="col-md-3 step-one text-center">
                        <p className="manage_permissions emb-chck">
                          <input
                            type="checkbox"
                            className="filled-in"
                            id="filled-in-box4"
                            checked={embroidery.semiGarmentForm}
                            disabled={this.state.disabled}

                            onChange={e => this.props.updateEmbroidery("semiGarmentForm", e.target.checked)}
                          />
                          <label for="filled-in-box4">Semi garment Form</label>
                        </p>
                      </div>
                      <div className="col-md-2 step-one text-center">
                        <p className="manage_permissions emb-chck">
                          <input
                            type="checkbox"
                            className="filled-in"
                            id="filled-in-box5"
                            checked={embroidery.tassel}
                            disabled={this.state.disabled}
                            onChange={e => this.props.updateEmbroidery("tassel", e.target.checked)}
                          />
                          <label for="filled-in-box5">Tassle</label>
                        </p>
                      </div>
                    </div>
                    {/* <div className="col-md-8 col-md-offset-2 no-padding"> */}
                    <div className="col-md-8 col-md-offset-2 no-padding">
                      <div className="process-allocation flex-fixed">
                        <div className="process-alloc-con process-left-con col-md-4 no-padding">
                          <select
                            id="mySelect"
                            onDoubleClick={() => this.props.moveToRight()}
                            className="mySelectLeft"
                            size="10"
                            style={{ display: "block" }}
                            disabled={this.state.disabled}
                          >
                            {embroidery.leftData.map((data) => {
                              return <option>{data}</option>
                            })}
                          </select>
                        </div>
                        {/* end of process-alloc-con */}
                        {!this.state.disabled && <div className="process-left-arrows">
                          <a onClick={() => this.props.moveToRight()}>
                            <span className="up">
                              <i className="fa fa-chevron-right" />
                            </span>
                          </a>
                          <a onClick={() => this.props.moveToBottom()}>
                            <span className="down">
                              <i className="fa fa-chevron-down" />
                            </span>
                          </a>
                        </div>}
                        <div className="process-alloc-con col-md-4 no-padding">
                          <select
                            id="mySelect2"
                            onDoubleClick={() => this.props.moveToLeft()}
                            className="mySelectRight"
                            size="10"
                            style={{ display: "block" }}
                            disabled={this.state.disabled}
                          >
                            {embroidery.rightData.map((data) => {
                              return <option>{data}</option>
                            })}
                          </select>
                        </div>
                        {/* end of process-alloc-con */}
                        {!this.state.disabled && <div className="process-nav-arrows">
                          <a onClick={() => this.props.moveToUp()}>
                            <span className="up">
                              <i className="fa fa-chevron-up" />
                            </span>
                          </a>
                          <a onClick={() => this.props.moveToLeft()}>
                            <span className="down"  >
                              <i className="fa fa-chevron-left" />
                            </span>
                          </a>
                        </div>}
                      </div>
                      {/* end of process-allocation */}
                    </div>
                    <div className="col-md-12 no-padding">
                      {/* <div className="col-md-4 step-one">
                        <Field
                            isFormGroup={true}
                            inputType="textarea"
                            inputName="additionalInfo"
                            value={embroidery.additionalInfo}
                            label="Additional Info"
                            index = {index}
                            onChange={this.props.updateEmbroidery}
                            disabled={this.state.disabled}
                        />
                      </div> */}
                      {/* end of col-md-3 */}
                      {/* <div className="col-md-3 step-one">
                        <div className="form-group">
                          <label>Employee Name</label>
                          <div class="custom-async-select">
                            <Async
                                name="employeeName"
                                value={embroidery.employeeName}
                            //   onInputChange={e =>
                            //     this.getPatternMaster(e, "cuttingMaster")
                            //   }
                                onChange={e => this.props.updateEmbroidery('employeeName',e.value,index)}
                                placeholder="Cutting master Name"
                                options={this.state.assignedToList}
                                disabled = {this.state.disabled}
                            />
                         </div>
                        </div>
                      </div> */}
                      {/* end of col-md-3 */}

                      <div className="col-md-12 nopadding">
                        <div class="col-md-12 hide-customer-site">
                          <FileUpload
                            Heading="Upload Images"
                            getRefImages={(refImages) => this.props.getRefImages(refImages, 'embroidery')}
                            disabled={this.state.disabled}
                            uploadedDocs={embroidery.refImages.length > 0 ? embroidery.refImages : null}
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 no-padding">
                      <div class="col-md-2 step-one">
                        <Field
                          isFormGroup={true}
                          inputType="checkboxToggle"
                          inputName="backing"
                          value={embroidery.backing}
                          label="backing"
                          className=""
                          onChange={this.props.updateEmbroidery}
                          disabled={this.state.disabled}
                        />
                      </div>
                      {/* <div className="col-md-2 step-one">
                        <Field
                          isFormGroup={true}
                          inputType="checkboxToggle"
                          inputName="smocking"
                          value={embroidery.smocking}
                          label="smocking"
                          className=""
                          onChange={this.props.updateEmbroidery}
                          disabled={this.state.disabled}
                        />
                      </div>
                      <div className="col-md-2 step-one">
                        <Field
                          isFormGroup={true}
                          inputType="checkboxToggle"
                          inputName="sheering"
                          value={embroidery.sheering}
                          label="sheering"
                          className=""
                          onChange={this.props.updateEmbroidery}
                          disabled={this.state.disabled}
                        />
                      </div> */}
                      {embroidery.backing && <div class="col-md-12 nopadding">
                        <div className="col-md-2 step-one">
                          <label> {"Backing "}</label>
                        </div>
                        <div className="col-md-2 step-one">
                          <label> {"Width "}</label>
                        </div>
                        <div className="col-md-2 step-one">
                          <label> {"Placement "}</label>
                        </div>
                        <div
                          class="col-md-1"
                        >
                          {!this.state.disabled &&
                            (permissions.create || permissions.edit) &&
                            <ButtonIcon
                              buttonType="add"
                              addRemoveFunc={() => this.props.changeBackingArray('add')}
                            />
                          }
                        </div>
                      </div>}

                      {embroidery.backing && embroidery.backingData.map((backingData, i) => (
                        <div class="col-md-12 nopadding">
                          <div className="col-md-2 step-one">
                            <Field
                              isFormGroup={false}
                              inputType="select"
                              inputName="backingType"
                              value={backingData.backingType}
                              options={this.state.BACKINGTYPE}
                              onChange={(name, value) => this.props.updateEmbroideryBackingData(name, value, i)}
                              label={"Backing "}
                              disabled={this.state.disabled}
                            />
                          </div>
                          <div className="col-md-2 step-one">
                            <Field
                              isFormGroup={false}
                              inputType="text"
                              inputName="width"
                              value={backingData.width}
                              // options={this.state.widthList}
                              onChange={(name, value) => this.props.updateEmbroideryBackingData(name, value, i)}
                              label={"Width"}
                              disabled={this.state.disabled}
                            />
                          </div>
                          <div className="col-md-2 step-one">
                            <Field
                              isFormGroup={false}
                              inputType="select"
                              inputName="placement"
                              value={backingData.placement}
                              options={this.state.PLACEMENT}
                              onChange={(name, value) => this.props.updateEmbroideryBackingData(name, value, i)}
                              label={"Placement "}
                              disabled={this.state.disabled}
                            />
                          </div>
                          <div
                            class="col-md-1"
                          >
                            {!this.state.disabled &&
                              (permissions.create || permissions.edit) &&
                              <ButtonIcon
                                buttonType="clear"
                                addRemoveFunc={() => this.props.changeBackingArray('clear', i)}
                              />
                            }
                          </div>
                        </div>
                      ))}
                    </div>
                    <div class="col-md-12 nopadding">
                      <table class="table">
                        <thead class="border-bottom-0">
                          <tr class="border-bottom-0">
                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              Emb Placement
                            </th>
                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              Emb form
                            </th>
                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              No of Colors
                            </th>
                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              Frames
                            </th>
                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              Stitches/Mtr
                            </th>
                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              Consumption/Unit
                            </th>
                            {/* <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            /> */}
                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              Stitches Count
                            </th>
                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              Prices/1000 Stitches
                            </th>
                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              {!this.state.disabled &&
                                (permissions.create || permissions.edit) &&
                                <ButtonIcon
                                  buttonType="add"
                                  addRemoveFunc={() => this.props.addEmbroideryData()}
                                />
                              }

                            </th>
                            {/* <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              Total(INR)
                            </th> */}
                            {/* <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            /> */}
                          </tr>
                        </thead>
                        <tbody>
                          {embroidery.embroideryData.map((embroideryData, i) => {
                            return <tr>
                              <td class="border-top-0">
                                <Field
                                  isFormGroup={false}
                                  inputType="select"
                                  inputName="embPlacement"
                                  value={embroideryData.embPlacement}
                                  options={this.state.PLACEMENT}
                                  onChange={(name, value) => this.props.updateEmbroideryData(name, value, i)}
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td class="border-top-0">
                                <Field
                                  isFormGroup={false}
                                  inputType="select"
                                  inputName="embForm"
                                  value={embroideryData.embForm}
                                  options={this.state.EMBFORM}
                                  onChange={(name, value) => this.props.updateEmbroideryData(name, value, i)}
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td class="border-top-0">
                                <Field
                                  isFormGroup={false}
                                  inputType="select"
                                  inputName="noOfCols"
                                  value={embroideryData.noOfCols}
                                  options={this.state.NOOFCOLORS}
                                  onChange={(name, value) => this.props.updateEmbroideryData(name, value, i)}
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td class="border-top-0">
                                <Field
                                  isFormGroup={false}
                                  inputType="select"
                                  inputName="frames"
                                  value={embroideryData.frames}
                                  options={this.state.FRAMES}
                                  onChange={(name, value) => this.props.updateEmbroideryData(name, value, i)}
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td class="border-top-0">
                                <Field
                                  isFormGroup={false}
                                  inputType="text"
                                  inputName="stitchesMtr"
                                  value={embroideryData.stitchesMtr}
                                  onChange={(name, value) => this.props.updateEmbroideryData(name, value, i)}
                                  disabled={this.state.disabled || (embroideryData.embForm && embroideryData.embForm.toLowerCase() === "panel")}
                                />
                              </td>
                              <td class="border-top-0 d-flex">
                                {/* <Field
                                  isFormGroup={false}
                                  inputType="text"
                                  inputName="consumption"
                                  value={embroideryData.consumption}
                                  onChange={(name,value) => this.props.updateEmbroideryData(name,value,index,i)}
                                  disabled={this.state.disabled}
                              /> */}
                                <input size={"6"} maxLength={"6"} type="text" name="consumption" value={embroideryData.consumption} className="form-control"
                                  disabled={this.state.disabled || (embroideryData.embForm && embroideryData.embForm.toLowerCase() === "panel")}
                                  onChange={(e) => this.props.updateEmbroideryData(e.target.name, e.target.value, i)}
                                />
                                {<span>{"/mtrs"}</span>}
                              </td>
                              {/* <td class="border-top-0" /> */}
                              <td class="border-top-0">
                                <Field
                                  isFormGroup={false}
                                  inputType="text"
                                  inputName="stitchCount"
                                  value={embroideryData.stitchCount}
                                  onChange={(name, value) => this.props.updateEmbroideryData(name, value, i)}
                                  // disabled={this.state.disabled || embroideryData.embForm == "length"}
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td class="border-top-0">
                                <Field
                                  isFormGroup={false}
                                  inputType="text"
                                  inputName="priceForStitches"
                                  value={embroideryData.priceForStitches}
                                  // options={this.state.PRICE1000STICHES&&this.state.PRICE1000STICHES.map(x => ({ label: x, value: x }))}
                                  onChange={(name, value) => this.props.updateEmbroideryData(name, value, i)}
                                  disabled={this.state.disabled}
                                // disabled={this.state.disabled || embroideryData.embForm == "length"}
                                />
                                {/* <Field
                                  isFormGroup={false}
                                  inputType="text"
                                  inputName="priceForStitches"
                                  value={embroideryData.priceForStitches}
                                  onChange={(name, value) => this.props.updateEmbroideryData(name, value, i)}
                                  disabled={this.state.disabled}
                                /> */}
                              </td>
                              <td class="border-top-0 pt-0 text-left">
                                {!this.state.disabled &&
                                  (permissions.create || permissions.edit) &&
                                  <ButtonIcon
                                    buttonType="clear"
                                    addRemoveFunc={() => this.props.removeEmbroideryData(i)}
                                  />
                                }
                              </td>
                            </tr>
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* End of content embroiedry */}
                  <div class="col-md-12 step-one">
                    <Field
                      isFormGroup={true}
                      inputType="textarea"
                      inputName="comments"
                      value={embroidery.comments}
                      label="comments"
                      onChange={this.props.updateEmbroidery}
                      disabled={this.state.disabled}
                    />
                  </div>
                </div>
              </form>
            </div>
            {permissions.create && permissions.edit && !this.state.disabled &&
              <div class="col-md-12 no-padding text-center profile-btn">
                <Button
                  buttonName={"save"}
                  onClick={e => this.props.saveEmbroidery(e)}
                />
                <Button
                  buttonName={"Complete"}
                  onClick={e => this.props.completeEmbroidery(e)}
                />
              </div>
            }
          </div>
          {/* } */}
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/SampleRequest/EmbroideryModule/index.js